import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { Box, IconButton, Paper, useTheme,Tooltip } from '@mui/material';
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap"
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { ListManager } from 'react-beautiful-dnd-grid';
import CustomCard from '../../components/@extended/CustomCard';
import { useSelector } from 'react-redux';
import { useUpdateDashboardPreferenceMutation } from '../../store/slices/apiSlice';
import {useMediaQuery} from '@mui/material';

const swapElements = (array, index1, index2) => {
  // Create a copy of the original array
  const newArray = [...array];
  // Store the element at index1 in a temporary variable
  const temp = newArray[index1];
  // Replace the element at index1 with the element at index2
  newArray[index1] = newArray[index2];
  // Replace the element at index2 with the element stored in the temporary variable
  newArray[index2] = temp;

  const _newArray = newArray.map((_widget, index) => {
    return {
      ..._widget,
      order: index,
    };
  });

  return _newArray;
};

const DragContainer2 = (props) => {
  const { widgets, maximizeWidget, userPreferences, selectedSitesCount = 0, widgetsPerRow: userWidgetsPerRow = 3 } = props;
  const userId = useSelector((state) => state.userDetails?.loggedInUser?.id);
  const [updateDashboardPreference] = useUpdateDashboardPreferenceMutation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  // Widgets per row: if more than 3 sites selected → 1 per row; else min(user preference, device max)
  const deviceMaxItems = isMobile ? 1 : isTablet ? 2 : 3;
  const maxItems = selectedSitesCount > 3 ? 1 : Math.min(Number(userWidgetsPerRow) || 3, deviceMaxItems);
  const itemWidth = maxItems === 1 ? '100%' : maxItems === 2 ? '50%' : '33.333%';

  // Visible widgets in display order (by preference.order); used for grid layout and reorder
  const [localItems, setLocalItems] = useState([]);
  useEffect(() => {
    if (widgets) {
      const withDisplay = Object.values(widgets)
        .filter((w) => w.display === true)
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .map((w) => ({ id: w.id, order: w.order, preferenceId: w.preferenceId }));
      setLocalItems(withDisplay);
    }
  }, [widgets]);

  const reorderList = async (sourceIndex, destinationIndex) => {
    let updatedList;
    setLocalItems((prev) => {
      const list = swapElements([...prev], sourceIndex, destinationIndex);
      updatedList = list;
      return list;
    });

    if (updatedList) {
      const _objList = updatedList.map((_list) => {
        return {
          id: _list.preferenceId,
          order: _list.order,
        };
      });
      const payload = {
        userId,
        preferences: _objList,
      };
      await updateDashboardPreference(payload);
    }
  };
  function ListElement({ item: { id } }) {
    const _selectedKey = Object.keys(widgets).find((key) => widgets[key].id === id);
    const _comp = widgets[_selectedKey];
    return (
      <Box sx={{ padding: 1.5 }}>
        {_comp?.label ? (
          <Box
            sx={{
              width: '100%',
              '& .MuiCardContent-root': { padding: 0 },
              '& .MuiCardContent-root:last-child ': { padding: 0 },
            }}
          >
            <CustomCard
              action={
                   (_comp?.id=="TRIAL_SUBJECT_ENROLLMENT_TREND" &&
                    <Tooltip title="Maximise Widget" placement="bottom-start">
                      <ZoomOutMapIcon  style={{color:"#999999",width:30,height:30,marginRight: "6px",cursor:"pointer"}} onClick={() =>maximizeWidget(_selectedKey)}/>
                    </Tooltip>
                   )
              }
              sx={{ height: 320 }}
              title={_comp.label}
            >
              {_comp?.content}
            </CustomCard>
          </Box>
        ) : (
          <Paper sx={{ width: '100%', height: 380 }}>{_comp?.content}</Paper>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ '& > *': { width: '100%' }, '& > * > *': { width: itemWidth } }}>
      <ListManager
        key={`dashboard-grid-${maxItems}`}
        items={localItems}
        direction="horizontal"
        maxItems={maxItems}
        render={(item) => <ListElement item={item} />}
        onDragEnd={reorderList}
      />
    </Box>
  );
};

export default DragContainer2;
